import { CLIENT_ID, CLIENT_SECRET } from "./constants";

export const encodeSecrets = () => {
  const decodedStringBtoA = `${CLIENT_ID}:${CLIENT_SECRET}`;
  const encodedStringBtoA = btoa(decodedStringBtoA);
  return encodedStringBtoA;
};
